import { useTranslate } from "ui/locale";
import { RedeemTab } from "./RedeemTabs.types";
import PartnersPage from "ui/partners/pages/PartnersPage/PartnersPage";
import GiftCardPage from "ui/common/pages/GiftCardPage/GiftCardPage";
import { PartnerType } from "ui/partners/types/PartnerType";
import RedeemTabIcon from "ui/redeem/components/RedeemTabIcon/RedeemTabIcon";

import physicalStoreIcon from "../../../assets/images/physicalStore.png"
import onlineStoreIcon from "../../../assets/images/onlineStore.png"
import giftCardIcon from "../../../assets/images/giftcard.png"

export const REDEEM_TABS: RedeemTab[] = [
    {
        label: "pointsSell",
        children: <PartnersPage />,
        path: PartnerType.PHYSICAL_STORE,
        icon: <RedeemTabIcon img={physicalStoreIcon} />,
    },
    {
        label: "onlineStore",
        children: <PartnersPage />,
        path: PartnerType.ONLINE_STORE,
        icon: <RedeemTabIcon img={onlineStoreIcon} />,
    },
    {
        label: "giftcards",
        children: <GiftCardPage />,
        path: "gift-cards",
        icon: <RedeemTabIcon img={giftCardIcon} />,
    },
];

export default function useRedeemTabs() {
    const translate = useTranslate();
    return REDEEM_TABS.map((tab) => ({
        ...tab,
        label: translate(tab.label),
    }));
}
